module.exports = __webpack_public_path__ + "static/mapBundle@2x-3070cc8b574b5ab8a0956386be136dbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/mapBundle@2x.png
// module id = 2615
// module chunks = 168707334958949